import { questionnaireGql } from '../../../data/gql-gen/questionnaire'

export const SET_KPI = questionnaireGql(/* GraphQL */ `
  mutation setKpiV2($input: SetKpiV2Input!) {
    setKpiV2(input: $input) {
      ...DraftQuestionnaireEntry
    }
  }
`)

export const REMOVE_KPI = questionnaireGql(/* GraphQL */ `
  mutation removeKpiV2($input: RemoveKpiV2Input!) {
    removeKpiV2(input: $input) {
      ...DraftQuestionnaireEntry
    }
  }
`)

export const SET_ROW_KPIS = questionnaireGql(/* GraphQL */ `
  mutation setRowKpisV2($input: SetRowKpisV2Input!) {
    setRowKpisV2(input: $input) {
      ...DraftQuestionnaireEntry
    }
  }
`)
